import { render, staticRenderFns } from "./TransferPlacesUpdateView.vue?vue&type=template&id=644b243d&scoped=true&"
import script from "./TransferPlacesUpdateView.vue?vue&type=script&lang=js&"
export * from "./TransferPlacesUpdateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644b243d",
  null
  
)

export default component.exports